import React from 'react';
import './LegendSingle.css';
import { PageTitle } from '../../../components';
import { FaCalendarAlt, FaUsers, FaClock } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { legends, titles } from '../../../constants';
import { useTranslation } from 'react-i18next';


const LegendSingle = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const legend = legends.find((item) => item.id.toString() === id);

    if (!legend) {
        return (
            <div className="container" style={{ padding: '100px 0', textAlign: 'center' }}>
                <h2>Nie znaleziono legendy.</h2>
            </div>
        );
    }

    return (
        <>
            {/* Page title - Now using 'legend' (single) instead of 'legends' (array) */}
            <PageTitle title={t(legend.title)} page={t('Legenda')} />

            <section className='legend-single'>
                <div className='legend-intro'>


                    <div className='information'>
                        <h3>{t(legend.title)}</h3>
                        <h5>{t(legend.subtitle)}</h5>

                        <div className='legend-about'>
                            <div className='text' style={{ whiteSpace: 'pre-line' }}>
                                {t(legend.content)}
                            </div>
                        </div>

                        {/* Meta Info */}
                        <ul className="legend-meta-info">
                            <li>
                                <h6><FaCalendarAlt className='icon' /> {t(titles.data)}:</h6>
                                <span>{t(legend.date)}</span>
                            </li>
                            <li>
                                <h6><FaUsers className='icon' /> {t(titles.authors)}:</h6>
                                <span>{t(legend.author)}</span>
                            </li>
                            <li>
                                <h6><FaClock className='icon' /> {t(titles.czytaj)}:</h6>
                                <span>{t(legend.readTime)}</span>
                            </li>
                        </ul>
                    </div>

                </div>
            </section>
        </>
    );
}

export default LegendSingle;